import _regenerator from "@babel/runtime/helpers/esm/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import rules from "@/assets/js/rules";
import { mapActions, mapGetters } from "vuex";
export default {
  data: function data() {
    return {
      sim: false,
      nao: false,
      telefoneWhatsapp: "",
      loading: false,
      formValid: false,
      rules: rules
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("auth", ["empresa", "identificador", "cliente"])), mapGetters("notification", ["dialogWhatsapp"])),
  watch: {
    dialogWhatsapp: function dialogWhatsapp(estaAberto) {
      if (!estaAberto) {
        this.resetarFormulario();
      } else {
        this.sim = false;
        this.nao = false;
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("notification", ["showDialogWhatsapp", "cadastrarWhatsapp"])), {}, {
    handleClick: function handleClick(valor, event) {
      if (valor === "sim") {
        this.sim = event;
        if (event) this.nao = !event;
        return;
      }
      this.nao = event;
      if (event) this.sim = !event;
      if (this.nao) {
        this.$store.commit('notification/setJaRespondeu', true);
        this.showDialogWhatsapp(false);
        this.resetarFormulario();
      }
    },
    enviarWhatsapp: function enviarWhatsapp() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$$refs$formWhats, _this$cliente;
        var formValido, identificador, payload, _this$cliente2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              formValido = (_this$$refs$formWhats = _this.$refs.formWhatsapp) === null || _this$$refs$formWhats === void 0 ? void 0 : _this$$refs$formWhats.validate();
              if (formValido) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _this.$store.state.chat.aberto = false;
              identificador = _this.$route.query.identificador || _this.identificador;
              payload = {
                cliente_id: ((_this$cliente = _this.cliente) === null || _this$cliente === void 0 ? void 0 : _this$cliente.id) || null,
                status: "ATIVO",
                numero: _this.telefoneWhatsapp.replace(/\D/g, ""),
                identificador: identificador
              };
              _this.loading = true;
              _context.p = 2;
              _this.$store.commit('notification/setJaRespondeu', true);
              _context.n = 3;
              return _this.cadastrarWhatsapp([payload, (_this$cliente2 = _this.cliente) === null || _this$cliente2 === void 0 ? void 0 : _this$cliente2.tem_whatsapp]);
            case 3:
              _context.p = 3;
              _this.loading = false;
              _this.showDialogWhatsapp(false);
              _this.resetarFormulario();
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[2,, 3, 4]]);
      }))();
    },
    resetarFormulario: function resetarFormulario() {
      this.sim = false;
      this.nao = false;
      this.telefoneWhatsapp = "";
      this.formValid = false;
      if (this.$refs.formWhatsapp) {
        this.$refs.formWhatsapp.resetValidation();
      }
    }
  })
};